import Prismic from "prismic-javascript";
// -- Prismic API endpoint
const apiEndpoint = "https://the-sunnyside-shop.cdn.prismic.io/api/v2";
// -- Access Token if the repository is not public
const accessToken =
  "MC5hWVMxX1JJQUFDY0F4bU1S.77-9PGvvv73vv73vv70NZu-_vSfvv71pTjjvv73vv70mJxN-SzDvv73vv73vv73vv73vv71lRybvv70x";
// -- Prismic Client
const PrismicClient = Prismic.client(apiEndpoint, { accessToken });

export default PrismicClient;
